/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateIcrTouchConnectionData
 */
export interface CreateIcrTouchConnectionData {
    /**
     * 
     * @type {string}
     * @memberof CreateIcrTouchConnectionData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIcrTouchConnectionData
     */
    tak: string;
}

/**
 * Check if a given object implements the CreateIcrTouchConnectionData interface.
 */
export function instanceOfCreateIcrTouchConnectionData(value: object): value is CreateIcrTouchConnectionData {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tak' in value) || value['tak'] === undefined) return false;
    return true;
}

export function CreateIcrTouchConnectionDataFromJSON(json: any): CreateIcrTouchConnectionData {
    return CreateIcrTouchConnectionDataFromJSONTyped(json, false);
}

export function CreateIcrTouchConnectionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIcrTouchConnectionData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'tak': json['tak'],
    };
}

  export function CreateIcrTouchConnectionDataToJSON(json: any): CreateIcrTouchConnectionData {
      return CreateIcrTouchConnectionDataToJSONTyped(json, false);
  }

  export function CreateIcrTouchConnectionDataToJSONTyped(value?: CreateIcrTouchConnectionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'tak': value['tak'],
    };
}

